module.exports = "/_next/static/images/72e8562a46f0dd60b1bb3ff0a0335a17-slide4desktop.jpg";